<template>
    <div style="background-color: white">
        <div>
            <img width="100%" height="auto" :src="type === '0' ? require('@/assets/联系客服2.jpg') :  require('@/assets/联系客服.png')">
        </div>
    </div>
</template>

<script>

    import Cookies from 'js-cookie'

    export default {
        name: "Help",
        data() {
            return {
                type: Cookies.get('type'),
            }
        }
    }
</script>

<style scoped>

</style>
